import React, {CSSProperties, FC} from "react";
import {Typography} from "antd";
import { ConversationStoryRow } from "./ConversationStoryRow";
import { TranscriptFeedbackRow } from "./TranscriptFeedbackRow";
import { InvestigationRow } from "./InvestigationRow";
import { DialogueChoicesRow } from "./DialogueChoicesRow";
import { Transcript } from "../components/ConversationStory/TranscriptModal";
import { Orders } from "../components/Investigation/OrdersModal";
import {Activity, DashboardView} from "../../../types";
import {LabelsProvider} from "../../../hooks/Labels";
import {GUTTER} from "../../../constants";
import {ChecklistFeedbackRow} from "./ChecklistFeedbackRow";
import {ConversationElicitRow} from "./ConversationElicitRow";
import { FeedbackModal, FeedbackModalContentFC } from "../components/Generic/FeedbackModal";
import {FeedbackRowProps} from "./types";

export const DashboardViewFeedbackCardMapping: { [key in DashboardView]?: FC<FeedbackRowProps> } = {
    [DashboardView.EXERCISE_CONVERSATION_STORY_COVERAGE]: ConversationStoryRow,
    [DashboardView.EXERCISE_CONVERSATION_ELICIT_PERFORMANCE]: ConversationElicitRow,
    [DashboardView.EXERCISE_TRANSCRIPT_COVERAGE]: TranscriptFeedbackRow,
    [DashboardView.EXERCISE_CHECKLIST_COVERAGE]: ChecklistFeedbackRow,
    [DashboardView.EXERCISE_INVESTIGATIONS_COVERAGE]: InvestigationRow,
    [DashboardView.EXERCISE_DIALOGUE_CHOICES_COVERAGE]: DialogueChoicesRow
}

export const DashboardViewTranscriptMapping: { [key in DashboardView]?: FeedbackModalContentFC } = {
    [DashboardView.EXERCISE_CONVERSATION_STORY_COVERAGE]: Transcript,
    [DashboardView.EXERCISE_TRANSCRIPT_COVERAGE]: Transcript,
    [DashboardView.EXERCISE_CHECKLIST_COVERAGE]: Transcript,
    [DashboardView.EXERCISE_DIALOGUE_CHOICES_COVERAGE]: Transcript,
    [DashboardView.EXERCISE_INVESTIGATIONS_COVERAGE]: Orders
}

const {Title} = Typography;

export const renderAttemptsFeedback = (activity?: Activity, style?: CSSProperties) =>
    activity?.renderers.map((renderer) => {
        const FeedbackRow = DashboardViewFeedbackCardMapping[renderer.dashboard_view];
        return FeedbackRow ? <LabelsProvider key={renderer.id} activityRenderer={renderer.id}>
            <FeedbackRow activityId={activity.id.toString()} style={style}/>
        </LabelsProvider> : null;
    })

export const renderStudentAttemptsFeedback = (activity: Activity, attemptId: string) =>
    activity.renderers.map((renderer) => {
        const FeedbackRow = DashboardViewFeedbackCardMapping[renderer.dashboard_view];
        const FeedbackModalContent = DashboardViewTranscriptMapping[renderer.dashboard_view];
        return FeedbackRow ? <LabelsProvider key={renderer.id} activityRenderer={renderer.id}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <Title level={3} style={{fontWeight: 400, marginTop: GUTTER[0]}}>{renderer.name}</Title>
                {FeedbackModalContent ? <FeedbackModal title={FeedbackModalContent.title}>
                    <FeedbackModalContent activityId={activity.id.toString()} attemptId={attemptId}/>
                </FeedbackModal> : null}
            </div>
            <FeedbackRow activityId={activity.id.toString()} attemptId={attemptId}/>
        </LabelsProvider> : null;
    })
